export default {
    ca: {
        title: 'Informació sobre les galetes',
		emailIcgc: 'icgc@icgc.cat'
    },
    es: {
        title: 'Informacion acerca de las galletas',
		emailIcgc: 'icgc@icgc.cat'
	},
    en: {
        title: 'Information about cookies',
		emailIcgc: 'icgc@icgc.cat'
	},
};



// WEBPACK FOOTER //
// ./src/politica/politica-translations.js